import React, { useState, useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Layout from '../components/common/Layout';
import MetaTag from '../components/common/MetaTag';
import MasterListNewTitleSection from '../components/master-list/MasterListNewTitleSection';

function MasterlistsNew() {
  const theme = useTheme();
  const isMdSmScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const [scrolled, setScrolled] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    function handleScroll() {
      const isScrolled = window.scrollY > 20;
      if (isScrolled !== scrolled) {
        setScrolled(!scrolled);
      }
    }

    document.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <Layout>
      <Grid container direction="column" alignItems="stretch">
        <Grid
          item
          sx={{
            backgroundImage: isMdSmScreen ? 'url(https://static.rakuna.co/images/career-fairs-spring-2023-fall-2023/masterlist-bg-mobile.png)' : 'url(https://static.rakuna.co/images/career-fairs-spring-2023-fall-2023/masterlist-bg-desktop.png)',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#ededed',
          }}
        >
          <MasterListNewTitleSection />
        </Grid>
      </Grid>
    </Layout>
  );
}

export default MasterlistsNew;

export function Head() {
  return (
    <MetaTag
      title="MasterList of College Career Fairs in U.S. 2024"
      description="The comprehensive list of 1000+ U.S. career fairs, virtual events included, in Fall 2023 - Spring 2024 with details on registration deadline, event time, and location"
      keywords="College Career Fair"
      slug="/career-fairs-fall-2023-spring-2024"
    />
  );
}
